import React, { useState } from "react";
import Swal from "sweetalert2";
import { createDepositEntry } from "../../../api/walletTransaction";

const DepositEntry = () => {
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes("@")) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid user email.",
      });
      return;
    }

    const quantity = Number(amount);
    if (!quantity || Number.isNaN(quantity) || quantity <= 0) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: "Please enter a valid USD amount.",
      });
      return;
    }

    try {
      setSubmitting(true);
      const response = await createDepositEntry({
        email: email.trim(),
        quantity,
      });

      if (response?.status === 201 || response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Deposit Added",
          text: "Deposit entry created successfully.",
          timer: 1600,
          showConfirmButton: false,
        });
        setEmail("");
        setAmount("");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err?.response?.data?.message || "Could not create deposit entry.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-7 col-lg-9 col-md-10">
        <div className="card">
          <div className="card-header border-0">
            <h4 className="heading mb-0">Deposit</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">User Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="user@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Amount (USD)</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder="Enter USD amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Create Deposit Entry"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositEntry;